module.exports = __webpack_public_path__ + "static/cloud-docs-fcffde399b2afc24c5b416b1e427384e.svg";